import { render, staticRenderFns } from "./CreateMailPrint.vue?vue&type=template&id=6cd15a91&scoped=true"
import script from "./CreateMailPrint.vue?vue&type=script&lang=js"
export * from "./CreateMailPrint.vue?vue&type=script&lang=js"
import style0 from "./CreateMailPrint.vue?vue&type=style&index=0&id=6cd15a91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd15a91",
  null
  
)

export default component.exports